import i18n from 'i18next';
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from 'react-i18next';
//import XHR from 'i18next-xhr-backend';
//import Backend from 'i18next-http-backend';

import languageEN from './en/translate.json';
import languageDE from './de/translate.json';
import languageES from './es/translate.json';

i18n
//.use(Backend)
.use(LanguageDetector)
.use(initReactI18next)
.init({
    resources: {
        en: languageEN,
        de: languageDE,
        es: languageES
    },
    //lng: "en",
    fallbackLng: "en",
    debug: true,
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: ".",
    interpolation: {
        escapeValue: false,
        formatSeparator: ",",
        format: (value, format, lng) => {
            if (format === 'formattedFloat') {
                return Intl.NumberFormat(lng).format(value.toFixed(1));
            }
            return value;
          }        
    },
    react: {
        useSuspense: false,
        wait: true,
        bindI18n: 'languageChanged loaded',
        bindStore: 'added removed',
        nsMode: 'default'
    }
})

export default i18n;
